
  import React, { useEffect, useMemo, useRef, useState } from 'react';
  import PropTypes from 'prop-types';
  import LabelInput from '../Input/labelInput/labelInput';
  import {countryCode} from "../countryCode/countryCode";
  import Config from "../../service/Config/config";
  import axios from "axios";
  import './location.css'


  const SearchLocation = ({
    handleCurrentLocationBlur,
    handleCurrentLocationChange,
    value,
    isError,
    isView = false,
    label="Location",
    setPincodeValue=() => {},
    astrickIcon = true,
    id='searchKeyElement'
  }) => {
    let autoComplete;

    const loadScript = (url, callback) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'search_current_location';
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (
            script.readyState === 'loaded' ||
            script.readyState === 'complete'
          ) {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        script.onload = () => callback();
      }
      let elm = document.querySelectorAll('head>script');
      for (let i = 0; i < elm.length; i++) {
        elm[i].remove();
      }
      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    };

    function handleScriptLoad(
      updateQuery,
      setLatLng,
      setIsblank,
      autoCompleteRef
    ) {
      setIsblank(false);
      autoComplete = new window.google.maps.places.Autocomplete(
        autoCompleteRef.current,
        {
          types: [],
          componentRestrictions: { country: countryCode.in },
        }
      );
      autoComplete.setFields([
        'address_component',
        'geometry',
        'formatted_address',
      ]);

      autoComplete.addListener('place_changed', () => {
        handlePlaceSelect(updateQuery, setLatLng, setIsblank);
      });
    }

    async function handlePlaceSelect(updateQuery, setLatLng, setIsblank) {
      setTimeout(() => {
        setIsblank(true);
      }, 100);
      const addressObject = autoComplete.getPlace();
      const query = addressObject?.formatted_address;
      const addressComponent = addressObject?.address_components
      addressComponent && addressComponent.map((val, i) => {
        if(val?.types[0] !== undefined && val?.types[0] === 'postal_code'){
          setPincodeValue(val?.short_name)
        }
      })

      handleCurrentLocationChange(query)
      updateQuery(query);
      setLatLng({
        lat: Number(addressObject?.geometry?.location.lat()).toFixed(6),
        lng: Number(addressObject?.geometry?.location.lng()).toFixed(6),
      });
    }

    const [query, setQuery] = useState(value);
    const [latlng, setLatLng] = useState('');
    const [isblank, setIsblank] = useState(false);
    const autoCompleteRef = useRef(null);

    useEffect(() => {
      setQuery(value);
    }, [value]);

    useEffect(() => {
      if (latlng !== null && latlng !== undefined && isblank === true) {
        handleCurrentLocationBlur(latlng);
      } else {
        handleCurrentLocationBlur(null);
      }
    }, [latlng, isblank]);

    async function saveData(query) {
      try {
        let url;
        url = Config.locations.saveLocation;
        const payload = {
          query_search: query,
          module: 'fission-account'
        };
        await axios.post(url, payload);
      } catch (error) {
      }
    };

    // useEffect(() => {
    //   if (query && query.length >=3) {
    //
    //   }
    // }, [query]);

    useEffect(() => {
      // loadScript(Config.googleAPI.placeSearch, () =>
      //   handleScriptLoad(setQuery, setLatLng, setIsblank, autoCompleteRef)
      // );
    }, []);

    const handleBlur = () => {
      setIsblank(false);
      handleCurrentLocationBlur(null);
    };

    const handleSearch = (e) => {
      e.preventDefault()
      if (query && query.length >=3) {
        saveData(query);
        loadScript(Config.googleAPI.placeSearch, () =>
            handleScriptLoad(setQuery, setLatLng, setIsblank, autoCompleteRef)
        );
      }
      setTimeout(() => {
        document.getElementById(`${id}`).focus();
        //  document.getElementById('search_current_location').setAttribute('src','');
      }, 5);
    }

    return (
        <>
          <div className="col-md-6 float-field mtk-05 d-flex">
            {query === "" && (
              <i className="fa fa-search location-search-icon" aria-hidden="true"></i>
            )}
            {query !== "" && (
              <i className="fa fa-times-circle remove-location-filter" aria-hidden="true" onClick={() => setQuery("")}></i>
            )}

            <input type="text"
                   className="form-control form-control-user text-padding"
                   placeholder=" "
                   onChange={(val) => {
                     setQuery(val.target.value);
                   }}
                   onBlur={handleBlur}
                   value={query}
                   ref={autoCompleteRef}
                   disabled={isView}
                   id={id}
            />

            <label className="large-label search-bar-placeholder">
              {label}  {astrickIcon && <i className="bi bi-asterisk astrick-icon"></i>}
            </label>
            <div className="col-2 mt-1">
              <a className="btn btn-outline-primary btn-primary colorBox borderColorBox" onClick={(e)=>{handleSearch(e)}}>🔍</a>
            </div>

          </div>
        </>
    );
  };

  SearchLocation.propTypes = {
    handleCurrentLocationBlur: PropTypes.func,
    handleCurrentLocationChange: PropTypes.func,
    value: PropTypes.any,
    isError: PropTypes.bool,
  };

  export default SearchLocation;
